import { createContext } from 'react';

export interface GracePeriod {
  days_left: number;
  expired: boolean;
  deadline: string;
}

interface GracePeriodContextValue {
  gracePeriod: GracePeriod | null;
}

const GracePeriodContext = createContext<GracePeriodContextValue>({ gracePeriod: null });
export default GracePeriodContext;
